<template>
  <div class="main-banner mb23">
    <div class="container">
      <div class="col-md-10 col-sm-10 col-md-offset-1 col-sm-offset-1">
      
        <div class="caption text-left cl-white" style="height:380px">
          <h2>&nbsp;</h2>
          <h2>&nbsp;</h2>
          <h2>&nbsp;</h2>
        </div>
        
        <form>
          <fieldset class="home-form-1 icon-field">
          
            <div class="col-md-4 col-sm-4 padd-0">
              <div class="form-group">
                <div class="icon-addon addon-lg">
                  <input type="text" class="form-control br-1" v-model="keyword" :placeholder="$t('home-banner.job-keywords')" v-on:keyup.enter="searchJobs" />
                  <label class="fa fa-pencil"></label>
                </div>
              </div>
              
            </div>
              
            <div class="col-md-3 col-sm-3 padd-0">
              <div class="form-group">
                <!--<NiceSelect :display-name="cityName" idt="city"
                       icon="fa fa-map-marker"
                       :default-value="$t('home-banner.all-cities')"
                       :values.sync="locations" :value.sync="city"
                       ></NiceSelect>-->
                <div class="icon-addon addon-lg">
                  <input type="text" class="form-control br-1" v-model="cityNames" :placeholder="$t('home-banner.all-cities')" readonly @click="openLocationModal" style="cursor:pointer;" />
                  <label class="fa fa-map-marker"></label>
                </div>
              </div>
            </div>
              
            <div class="col-md-3 col-sm-3 padd-0">
              <NiceSelect :display-name="salaryName" idt="salary"
                       icon="fa fa-yen"
                       :default-value="$t('home-banner.all')"
                       :values="salaryRange" :value.sync="salary"></NiceSelect>
              
            </div>
              
            <div class="col-md-2 col-sm-2 padd-0">
              <button type="button" class="btn theme-btn cl-white seub-btn" v-on:click.prevent="searchJobs">{{ $t('home-banner.search-button') }}</button>
            </div>
              
          </fieldset>
                  <div class="keyword">
                      <p>{{ $t('home-banner.hot-functions') }} :</p>
                      <ul id="hot-functions">
                          <li v-for="f in functions.slice(0,5)"><a href="javascript:void(0)" @click="goJobs(f.c_name)">{{ $i18n.locale === 'zh' ? f.c_name:f.e_name }}</a></li>
                          <li><router-link :to="'/jobs?intern=1&t=' + Date.now()">实习生基地</router-link></li>
                      </ul>
                  </div>
        </form>
        <div class="text-center">

          <div class="choose-opt" style="margin: 15px auto;">
            <div class="choose-opt-box"><span>{{ $t('home-banner.or') }}</span></div>
          </div>
          <a href="javascript:void(0)" data-toggle="modal" data-target="#subscribe" class="btn theme-btn btn-m mrg-5">{{ $t('nav.subscribe') }}</a>
          <a :href="loginUrl" class="btn btn-hiring btn-m mrg-5">{{ $t('nav.signup') }}</a>
        </div>
        
      </div>
    </div>
    <LocationModal :locations="locations" :values="city" @selected="setLocations" />
  </div>
</template>
<style>
.mb23 {
  background-image: url(/img/homepage-title.jpg);
  padding-bottom: 30px;
  background-position-y:145px !important;
  background-size:auto 800px !important;
}
@media only screen and (max-width:480px) {
  .mb23 {
    background-image: url(/img/mobie-1.jpg);
    background-position-y:56px !important;
    background-size: cover !important;
  }
}
</style>
<script>
import NiceSelect from '@/components/NiceSelect.vue'
import LocationModal from '@/components/LocationModal.vue'

export default {
  name: 'HomeBanner',
  props: ['functions', 'locations'],
  components: {
    NiceSelect,
    LocationModal
  },
  data: function () {
  return {
    bgImg: '/img/shutterstock_54120526.jpg',
    city: [],
    cname: [],
    salary: 0,
    keyword: '',
    cityName: 'home-banner.city',
    salaryName: 'home-banner.salary-range',
    cityNames: null
  }
  },
  computed: {
    isLogedIn: function() {
      return this.$store.state.user != null
    },
    loginUrl: function() {
      //let path = this.$route.path
      let url = this.API_PREFIX + '/api/acca/signin?redirect_url=' + encodeURIComponent(this.API_PREFIX + '/home/#' + this.$route.path)
      //console.log(this.$route.path)
      return url
    }
  },
  mounted: function() {
    //console.log('ok')
    $('select').niceSelect();
  },
  watch: {
    locations: function() {
      //console.log(this.locations)
      setTimeout(function() {
        $('select').niceSelect();
      }, 100)
      /*this.$nextTick(function () {
       $('select').niceSelect();
    })*/
    },
    "i18n.locale": function() {
      //this.cityName = this.$t('home-banner.city')
      //this.salaryName = this.$t('home-banner.salary-range')
    }
  },
  methods: {
    setLocations: function(c) {
      this.city = []
      this.cname = []
      for (let i = 0; i < c.length; i ++) {
        this.city.push(c[i].id)
        this.cname.push(c[i].name)
      }
      if (c.length > 0) {
        this.cityNames = this.cname.join(',')
      } else
        this.cityNames = null
    },
    openLocationModal: function() {
      this.$nextTick (function () {
      $('#location-modal').modal('show')
    })
    },
    goJobs: function(keyword) {
      this.$router.push({
          path: '/jobs',
          query: {
            keyword: encodeURI(keyword)
          }
        })
    },
    searchJobs: function() {
    let salary = $('select#salary').val()

    this.$router.push({
          path: '/jobs',
          query: {
            locations_id: this.city.join(','),
            keyword: encodeURI(this.keyword),
            salary: salary
          }
        })

    }
  }
}
</script>
